












import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MenuItem from '@/components/menu/menu-item.vue';
import MainMenuGroupingMixin from '@/views/layout/navigation/mixins/main-menu-grouping-mixin';


@Component({
  components: {
    MenuItem
  }
})
export default class MainMenuGroupingMobile extends mixins(MainMenuGroupingMixin) {
 handleOpenMobileMenu() {
    // const mobileGrouping = this.$refs.mobileGrouping as Vue;
    // const rect = mobileGrouping.$el.getBoundingClientRect();

    // this.$store.commit('mobileMenuGroupingTop', rect.top);

    this.$store.commit('mobileMenuGroupingTop', 40);

    const { menuGroupingOpen } = this.$store.state.mobile;
    this.$helpers.afterBrowserRedraw(() => {
      this.$store.commit('mobileMenuGroupingOpen', !menuGroupingOpen);
    });
  }
}
